<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import riskMatrixAPI from "@/services/standards/riskMatrix/riskMatrixAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import hazardIdentificationAPI from "@/services/standards/hazardIdentification/hazardIdentificationAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

/**
 * 4.1.2 Identificación de peligros — listado de versiones de la Matriz de Riesgos IPEVR.
 * Reemplaza la subida de Excel por matriz editable online (GTC-45) versionable + evidencias + PDF firmado.
 */
export default {
  page: {
    title: "4.1.2 Identificación de peligros con participación de todos los niveles de la organización",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "4.1.2 Identificación de peligros con participación de todos los niveles de la organización",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "4.1.2 Identificación de peligros", active: true },
      ],
      lista: [],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      // Flujo anterior (subida de archivo diligenciado) — se conserva junto al form online.
      legacyList: [],
      legacyFile: null,
      legacySaving: false,
      legacyLastId: 1,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(42).then((r) => { this.itemData = r; }).catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    dateConvert(date) { return dateFormat(date); },
    statusBadgeClass(s) { return s === "signed" ? "badge-success" : "badge-secondary"; },
    statusText(s) { return s === "signed" ? "Firmada" : "Borrador"; },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 42)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((e) => console.log(e));
    },
    changeItemStatus(itemStatus) {
      newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 42, status: itemStatus })
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "¡Estado del ítem actualizado!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1500);
        })
        .catch((e) => { Swal.fire({ title: "¡ERROR!", text: "¡No se actualizó el estado!", icon: "error" }); console.log(e); });
    },

    downloadFormat() {
      const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/1/Identificación-Peligros/MATRIZ_DE_RIESGOS_LABORALES .xlsx";
      window.location.href = url;
    },
    downloadPdf(id) { window.open(riskMatrixAPI.pdfUrl(id), "_blank"); },
    newMatrix() { this.$router.push({ path: `/forms/estandares/${this.companyID}/matriz-riesgos` }); },
    editMatrix(id) { this.$router.push({ path: `/forms/estandares/${this.companyID}/matriz-riesgos/${id}` }); },

    cloneMatrix(id) {
      Swal.fire({
        title: "¿Crear nueva versión?",
        text: "Se clonarán los peligros de esta versión en una nueva editable.",
        icon: "question", showCancelButton: true, confirmButtonText: "Crear versión", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        riskMatrixAPI.cloneVersion(id).then((r) => {
          if (r && r.id) this.editMatrix(r.id);
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo clonar", "error"); });
      });
    },
    deleteMatrix(id) {
      Swal.fire({
        title: "¿Eliminar versión?", text: "Se eliminará la matriz, sus peligros y evidencias.",
        icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        riskMatrixAPI.delete(id).then(() => {
          Swal.fire({ title: "Eliminada", icon: "success", timer: 1300, showConfirmButton: false });
          this.getList();
        }).catch((e) => { console.log(e); Swal.fire("Error", "No se pudo eliminar", "error"); });
      });
    },
    getList() {
      this.loading = true;
      riskMatrixAPI.getAll(this.companyID, 1)
        .then((response) => {
          this.lista = (response && response.List && response.List.data) ? response.List.data : [];
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    goBack() { this.$router.go(-1); },

    // ---- Flujo anterior: subida/listado de archivo diligenciado (hazard_identification) ----
    getLegacyList() {
      hazardIdentificationAPI.getAllIdentificationCompany(this.companyID, 1, "")
        .then((response) => {
          this.legacyList = (response && response.employees && response.employees.data) ? response.employees.data : [];
          if (this.legacyList.length && this.legacyList[0].id) {
            this.legacyLastId = this.legacyList[0].id + 1;
          }
        })
        .catch((error) => { console.log(error); });
    },

    async uploadLegacyDocument() {
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const url = `${base}/${this.company.nit}/4.1.2/${this.legacyLastId}/${this.legacyFile.name}`;
        const ok = await uploadDocument(url, this.legacyFile);
        return ok ? `${process.env.VUE_APP_BUCKET}/${url}` : null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },

    async saveLegacy() {
      if (!this.legacyFile) {
        Swal.fire("Atención", "Selecciona un archivo primero.", "warning");
        return;
      }
      this.legacySaving = true;
      const link = await this.uploadLegacyDocument();
      if (!link) {
        this.legacySaving = false;
        Swal.fire("Error", "No se pudo subir el archivo al almacenamiento.", "error");
        return;
      }
      hazardIdentificationAPI.save({ file: link, companies_id: this.companyID })
        .then(() => {
          this.legacySaving = false;
          this.legacyFile = null;
          Swal.fire({ title: "Éxito", text: "Archivo cargado correctamente.", icon: "success", timer: 1600, showConfirmButton: false });
          this.getLegacyList();
        })
        .catch((error) => {
          this.legacySaving = false;
          console.log(error);
          Swal.fire("Error", "No se pudo registrar el archivo.", "error");
        });
    },

    deleteLegacy(id) {
      Swal.fire({
        title: "¿Eliminar archivo?",
        text: "Se quitará este documento cargado.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        hazardIdentificationAPI.deleteIdentification(id)
          .then(() => {
            Swal.fire({ title: "Éxito", text: "Archivo eliminado.", icon: "success", timer: 1500, showConfirmButton: false });
            this.getLegacyList();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "No se pudo eliminar el archivo.", "error");
          });
      });
    },

    openFile(url) {
      window.open(url, "_blank");
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
    this.getLegacyList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Edita la matriz de identificación de peligros y valoración de riesgos (IPEVR, GTC-45) en línea: cada
                      versión queda en el historial, la plataforma calcula el nivel de riesgo y la aceptabilidad, puedes
                      cargar evidencias de la participación de los colaboradores y firmar la matriz. La participación de
                      todos los niveles se puede lograr mediante capacitaciones, encuestas, inspecciones, etc.
                    </p>
                  </CheckModal>
                </div>
                <div class="col-md-6 text-right m-b-0">
                  <a :href="`/forms/matriz`" class="mx-1">Instrucciones</a>
                  <button :disabled="!allowAccess()" @click="downloadFormat" class="btn btn-light mx-1">
                    <i class="bx bx-download"></i> Formato (Excel)
                  </button>
                  <button :disabled="!allowAccess() || !getRole('Crear')" @click="newMatrix" class="btn btn-primary mx-1">
                    <i class="mdi mdi-plus"></i> Nueva matriz
                  </button>
                </div>
              </div>

              <div class="row pt-2">
                <div class="form-row col-md-6 col-sm-12">
                  <b-form-group class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                      <thead>
                        <tr>
                          <th class="text-center align-middle">Versión</th>
                          <th class="text-center align-middle">Fecha</th>
                          <th class="text-center align-middle">Peligros</th>
                          <th class="text-center align-middle">Evidencias</th>
                          <th class="text-center align-middle">Estado</th>
                          <th class="text-center align-middle">Descargar PDF</th>
                          <th class="text-center align-middle">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-if="loading"><td colspan="7" class="text-center"><b-spinner variant="primary" small></b-spinner></td></tr>
                        <tr v-else-if="!lista.length"><td colspan="7" class="text-center text-muted">No hay matrices registradas.</td></tr>
                        <tr v-for="dato in lista" :key="dato.id">
                          <td class="text-center align-middle font-weight-bold">{{ dato.version }}</td>
                          <td class="text-center align-middle">{{ dateConvert(dato.fecha) }}</td>
                          <td class="text-center align-middle">{{ dato.rows_count }}</td>
                          <td class="text-center align-middle">{{ dato.evidence_count }}</td>
                          <td class="text-center align-middle">
                            <span class="badge" :class="statusBadgeClass(dato.workflow_status)">{{ statusText(dato.workflow_status) }}</span>
                          </td>
                          <td class="text-center align-middle">
                            <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                              type="button" @click="downloadPdf(dato.id)" title="Descargar PDF branded">
                              <i class="mdi mdi-file-pdf-box" style="font-size:1.4rem; color:#c0392b;"></i>
                            </button>
                          </td>
                          <td class="text-center align-middle">
                            <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                              <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                              <b-dropdown-item :disabled="!getRole('Editar')" @click="editMatrix(dato.id)">
                                {{ dato.workflow_status === 'signed' ? 'Ver' : 'Editar' }}
                              </b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Crear')" @click="cloneMatrix(dato.id)">Nueva versión (clonar)</b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteMatrix(dato.id)">Eliminar</b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Flujo anterior: subir/listar archivo diligenciado (se conserva junto al form online) -->
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h5 class="mb-1">Documento diligenciado</h5>
                  <p class="text-muted mb-3">
                    Opción alternativa: descarga el formato, diligéncialo, fírmalo y súbelo aquí!
                  </p>
                </div>
              </div>

              <form class="form-group" @submit.prevent="saveLegacy" v-if="allowAccess()">
                <div class="form-row">
                  <b-form-group class="col-md-9 px-2" label="Subir archivo diligenciado" label-for="legacyFile">
                    <b-form-file :disabled="!getRole('Crear')" id="legacyFile" ref="legacyFile" name="legacyFile"
                      browse-text="Buscar" placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                      v-model="legacyFile"
                      accept=".doc,.pdf,.xlsx,.xls,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                  <div class="col-md-3 px-2 d-flex align-items-end">
                    <button :disabled="!getRole('Crear') || !legacyFile || legacySaving" type="submit"
                      class="btn btn-outline-primary mb-3 w-100">
                      <b-spinner small v-if="legacySaving"></b-spinner>
                      <span v-else><i class="bx bx-upload"></i> Subir Matriz de Riesgos</span>
                    </button>
                  </div>
                </div>
              </form>

              <div class="table-responsive" v-if="getRole('Consultar') || !allowAccess()">
                <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                  <thead>
                    <tr>
                      <th class="text-center align-middle">Fecha de carga</th>
                      <th class="text-center align-middle">Documento</th>
                      <th class="text-center align-middle">Ver archivo</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-if="!legacyList.length">
                      <td colspan="4" class="text-center text-muted">No hay documentos cargados por este método.</td>
                    </tr>
                    <tr v-for="dato in legacyList" :key="dato.id">
                      <td class="text-center align-middle">{{ dateConvert(dato.updated_at) }}</td>
                      <td class="text-center align-middle">Matriz de identificación de peligros</td>
                      <td class="text-center align-middle">
                        <span v-if="!dato.file" class="text-muted">No disponible</span>
                        <button v-else :disabled="!allowAccess()"
                          style="background-color: transparent !important; border: none;" type="button"
                          @click="openFile(dato.file)" title="Descargar archivo">
                          <i class="mdi mdi-cloud-download" style="font-size:1.3rem;"></i>
                        </button>
                      </td>
                      <td class="text-center align-middle">
                        <button :disabled="!allowAccess() || !getRole('Eliminar')"
                          style="background-color: transparent !important; border: none;" type="button"
                          @click="deleteLegacy(dato.id)" title="Eliminar">
                          <i class="mdi mdi-trash-can-outline" style="font-size:1.3rem; color:#c0392b;"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal { background-color: transparent !important; border: none; }
</style>
